import { createAction, props, union } from '@ngrx/store';

import { BomExportStatus } from '@cdba/user-interaction/model/feature/bom-export';
import { InteractionType } from '@cdba/user-interaction/model/interaction-type.enum';

export const showSnackBar = createAction(
  '[UserInteraction] Show Snack Bar',
  props<{ interactionType: InteractionType }>()
);

export const loadInitialBomExportStatus = createAction(
  '[UserInteraction] Load initial BOM Export status'
);

export const loadInitialBomExportStatusSuccess = createAction(
  '[UserInteraction] Load initial BOM Export status Success',
  props<{ status: BomExportStatus }>()
);

export const loadInitialBomExportStatusFailure = createAction(
  '[UserInteraction] Load initial BOM Export status Failure',
  props<{ errorMessage: string }>()
);

export const resetBomExportStatusTracking = createAction(
  '[UserInteraction] Reset tracking'
);

export const trackBomExportStatus = createAction(
  '[UserInteraction] Start tracking status'
);

export const updateBomExportStatus = createAction(
  '[UserInteraction] Update status',
  props<{ currentStatus: BomExportStatus }>()
);

export const trackBomExportStatusCompleted = createAction(
  '[UserInteraction] Stop tracking status - Completed'
);

export const trackBomExportStatusFailure = createAction(
  '[UserInteraction] Stop tracking status - Failure',
  props<{ errorMessage: string }>()
);

const all = union({
  showSnackBar,
  resetBomExportStatusTracking,
  updateBomExportStatus,
  trackBomExportStatus,
  trackBomExportStatusCompleted,
  trackBomExportStatusFailure,
});
export type UserInteractionActions = typeof all;
